import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type SheetFooterProps = ComponentProps<'div'>;

const SheetFooter = ({ className, ...props }: SheetFooterProps) => {
  return (
    <div
      data-slot="sheet-footer"
      className={cn('mt-auto flex flex-col gap-2 px-6 py-4', className)}
      {...props}
    />
  );
};

export default SheetFooter;
